import React, { useCallback } from "react";
import { ProductSearch } from "../Products/ProductSearch";
import { useIntl } from "react-intl";
import { ProductListItemProduct } from "../Products/ProductListItem";
import { useBarcodeScanner } from "@/src/common/useBarcodeScanner";
import { fetchQuery, graphql, useRelayEnvironment } from "react-relay";
import { LinkProductComponentQuery } from "./__generated__/LinkProductComponentQuery.graphql";
import * as Sentry from "@sentry/react-native";
export function LinkProductComponent(props: {
  onPressProduct: (product: ProductListItemProduct) => void;
  linkedProductIds: string[];
  inBottomSheet?: boolean;
}) {
  const intl = useIntl();
  const [query, setQuery] = React.useState("");

  const env = useRelayEnvironment();

  const { onPressProduct, linkedProductIds } = props;
  useBarcodeScanner(
    useCallback(
      async (ean: string) => {
        setQuery(ean);

        const data = await fetchQuery<LinkProductComponentQuery>(
          env,
          graphql`
            query LinkProductComponentQuery($ean: String!) {
              currentStore @required(action: THROW) {
                productByEAN(ean: $ean) {
                  id
                  imageUrl
                  name
                  partNumber
                }
              }
            }
          `,
          { ean }
        )
          .toPromise()
          .catch((error) => {
            Sentry.captureException(error);
            console.error("Error fetching product by EAN:", error);
            return null;
          });

        if (
          data?.currentStore.productByEAN &&
          !linkedProductIds.includes(data.currentStore.productByEAN.id)
        ) {
          onPressProduct(data.currentStore.productByEAN);
        } else {
        }
      },
      [setQuery, env, onPressProduct, linkedProductIds]
    )
  );

  return (
    <ProductSearch
      query={query}
      onChange={(e) => {
        setQuery(e.nativeEvent.text);
      }}
      autoFocus
      isSearching
      productIsDisabled={(id) =>
        props.linkedProductIds.includes(id)
          ? intl.formatMessage({
              defaultMessage: "Product is already linked",
              description: "LinkProductComponent disabled product reason",
            })
          : undefined
      }
      onPressProduct={props.onPressProduct}
      inBottomSheet={props.inBottomSheet}
    />
  );
}
